import { Button, Grid, Input, Link, Radio, Select, Typography } from "@arco-design/web-react";
import { IconDelete } from "@arco-design/web-react/icon";
import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import ContactListDropdown from "../ContactListDropdown";
import NewContactListDialog from "../../../ContactLists/NewContactListDialog";
import AddDropdownFooter from "../../../Components/AddDropdownFooter";

const { Row, Col } = Grid;
const Option = Select.Option;
const { Text } = Typography;

// Always-editable broadcast settings: fields are live, Save enables only when the
// form differs from the loaded record (isDirty, computed by the parent), and a
// Discard reverts while dirty. handleSave is the parent's live-guarded save.
const DELETE_BUTTON_TEXT = "Delete"


export default function BroadcastSettingsEditor({
    broadcastName, setBroadcastName,
    broadcastType, setBroadcastType,
    broadcastDescription, setBroadcastDescription,
    senderEmailId, setSenderEmailId,
    contactListFilterId,
    allContactListItems,
    setAllContactListItems,
    confirmedSenderEmails,
    handleContactListIdChange,
    allSegmentItems,
    segmentId,
    handleSegmentIdChange,
    audienceType,
    setAudienceType,
    handleSave,
    isDirty,
    onDiscard,
    handleDelete,
    record,
    setFromRecord,
}) {

    let history = useNavigate();

    const [addListOpen, setAddListOpen] = useState(false);
    const [segOpen, setSegOpen] = useState(false);

    // A list created via the inline "New list" footer: add it to the options and
    // select it as the broadcast's audience (the POST returned the full record).
    const handleListCreated = (created) => {
        if (!created || !created.id) return;
        setAllContactListItems && setAllContactListItems((prev) => [...(prev || []), created]);
        handleContactListIdChange({ target: { value: created.id } });
        setAddListOpen(false);
    };

    return (
        <Row>
            <Col span={24}>
                <div style={{ fontSize: 12, color: "var(--color-text-3)", marginBottom: 4 }}>Name</div>
                <Input
                    autoFocus                    value={broadcastName}
                    onChange={(value) => {
                        setBroadcastName(value);
                    }}
                />
            </Col>
            <Col span={24}>
                <div style={{ fontSize: 12, color: "var(--color-text-3)", marginTop: 16, marginBottom: 4 }}>Category</div>
                <Input
                    autoFocus                    value={broadcastDescription}
                    onChange={(value) => {
                        setBroadcastDescription(value);
                    }}
                />
            </Col>
            <Col span={24}>

                {
                    confirmedSenderEmails.length > 0 && (
                        <div style={{ paddingBottom: "10px", marginTop: 16 }}>
                            <div style={{ fontSize: 12, color: "var(--color-text-3)", marginBottom: 4 }}>Broadcast Email Sender</div>
                            <Select
                                value={senderEmailId}
                                onChange={(value) => { setSenderEmailId(value) }}                            >
                                {
                                    confirmedSenderEmails.map((item, index) => {
                                        return (
                                            <Option key={item.id} value={item.id}>{item.name} ({item.email})</Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                    )
                }

                {
                    confirmedSenderEmails.length == 0 && (
                        <Text type="secondary">No sender emails have been verified, <Link
                            style={{ cursor: "pointer" }}
                            onClick={() => history("/settings")}
                        >check settings</Link></Text>
                    )

                }

            </Col>

            <Col span={24}>
                <div style={{ fontSize: 12, color: "var(--color-text-3)", marginBottom: 4 }}>Audience</div>
                <Radio.Group
                    type="button"
                    value={audienceType}
                    onChange={(v) => setAudienceType(v)}
                    style={{ marginBottom: 12 }}
                    options={[
                        { label: "Contact list", value: "list" },
                        { label: "Segment", value: "segment" },
                    ]}
                />
                {audienceType === "segment" ? (
                    <Select
                        placeholder="Choose a segment"
                        style={{ width: "100%" }}
                        value={segmentId || undefined}
                        onChange={(v) => handleSegmentIdChange(v)}
                        popupVisible={segOpen}
                        onVisibleChange={setSegOpen}
                        options={(allSegmentItems || []).map((s) => ({
                            // A broadcast reaches only those who can be mailed.
                            label: s.name + " (" + (s.mailable_count || 0).toLocaleString() + " can be mailed)",
                            value: s.id,
                        }))}
                        dropdownRender={(menu) => (
                            <div>
                                {menu}
                                <AddDropdownFooter
                                    label="New segment"
                                    onClick={() => { setSegOpen(false); history("/segments"); }}
                                />
                            </div>
                        )}
                    />
                ) : (
                    <ContactListDropdown
                        allContactListItems={allContactListItems}
                        contactListFilterId={contactListFilterId}
                        handleContactListIdChange={handleContactListIdChange}
                        onAddNew={() => setAddListOpen(true)}
                    />
                )}
                <NewContactListDialog
                    open={addListOpen}
                    onClose={() => setAddListOpen(false)}
                    onCreated={handleListCreated}
                />
            </Col>

            <Col span={24} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Button type="primary" onClick={handleSave} disabled={!isDirty}>Save</Button>
                {isDirty && <Button onClick={onDiscard}>Discard</Button>}
                <div style={{ flex: 1 }} />
                <Button type="secondary" status="danger" onClick={handleDelete} icon={<IconDelete />}>
                    {DELETE_BUTTON_TEXT}
                </Button>
            </Col>
            <Col span={24}>

            </Col>
        </Row>
    )
}
